import { FeatureTeamEvent, TrackingEventType, useAnalytics } from '@capsicum/common';
import {
	type WalletConnectConfirmActionProps,
	WalletConnectConfirmationActions,
	type WalletConnectConfirmationActionsPayload
} from '@socios-blk/core';
import { useCallback } from 'react';

export const useWalletConnectAnalytics = (confirmActionProps: WalletConnectConfirmActionProps) => {
	const analytics = useAnalytics();

	const sendWalletConnectAnalytics = useCallback(() => {
		switch (confirmActionProps.action) {
			case WalletConnectConfirmationActions.AUTH_DAPP: {
				// Send dApp connection success analytic event via Segment
				['auth_click_wc', 'GA::confirm_connection_dapp'].forEach(event => {
					analytics.sendEvent(TrackingEventType.track, event, {
						feature_team: FeatureTeamEvent.FFT
					});
				});

				break;
			}
			case WalletConnectConfirmationActions.SEND_TRANSACTION:
			case WalletConnectConfirmationActions.TRANSFER:
			case WalletConnectConfirmationActions.TRANSFER_FROM:
			case WalletConnectConfirmationActions.UNSTAKE: {
				// Send aforementioned transaction signing event via Segment
				['transaction_success_wc', 'GA::confirm_transaction_dapp'].forEach(event => {
					analytics.sendEvent(TrackingEventType.track, event, {
						chz_amount: confirmActionProps.payload.value,
						extra_parameter: confirmActionProps.origin,
						feature_team: FeatureTeamEvent.FFT,
						text: confirmActionProps.action
					});
				});

				break;
			}

			case WalletConnectConfirmationActions.SIGN_MESSAGE:
			case WalletConnectConfirmationActions.ETH_SIGN:
			case WalletConnectConfirmationActions.ETH_SIGN_TYPED_DATA_V4: {
				['sign_message_success_wc', 'GA::confirm_sign_message_dapp'].forEach(event => {
					analytics.sendEvent(TrackingEventType.track, event, {
						extra_parameter: confirmActionProps.origin,
						feature_team: FeatureTeamEvent.FFT,
						text: confirmActionProps.action
					});
				});
				break;
			}
			// Send aforementioned transaction signing event to Google Analytics (GA)

			case WalletConnectConfirmationActions.STAKE:
			case WalletConnectConfirmationActions.CLAIM: {
				const payload =
					confirmActionProps.payload as unknown as WalletConnectConfirmationActionsPayload[WalletConnectConfirmationActions.SEND_TRANSACTION];

				// Send Stake & Clacim transaction signing event via Segment
				['transaction_success_wc', 'GA::confirm_transaction_dapp'].forEach(event => {
					analytics.sendEvent(TrackingEventType.track, event, {
						chz_amount: payload.value,
						extra_parameter: confirmActionProps.origin,
						feature_team: FeatureTeamEvent.FFT,
						text: confirmActionProps.action
					});
				});
				break;
			}
		}
	}, [analytics, confirmActionProps]);

	return {
		sendWalletConnectAnalytics
	};
};
